import { describeFields } from '../common/fields';
import { CourseSchema } from './schemas';

export const COURSE_FIELDS = describeFields(CourseSchema, {
  id: {},
  subject: {},
  label: {},
  grade: {},
  shortLabel: {},
});
